export default __webpack_public_path__ + "static/media/IcDatabase.6b0fbdfb.svg";